/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreamingPlatform } from './StreamingPlatform';
import {
    StreamingPlatformFromJSON,
    StreamingPlatformFromJSONTyped,
    StreamingPlatformToJSON,
    StreamingPlatformToJSONTyped,
} from './StreamingPlatform';
import type { LiveStreamUser } from './LiveStreamUser';
import {
    LiveStreamUserFromJSON,
    LiveStreamUserFromJSONTyped,
    LiveStreamUserToJSON,
    LiveStreamUserToJSONTyped,
} from './LiveStreamUser';

/**
 * 
 * @export
 * @interface LiveStreamItem
 */
export interface LiveStreamItem {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    type?: LiveStreamItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    competitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    competitionName?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    competitionType?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    matchId?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    label?: string;
    /**
     * 
     * @type {StreamingPlatform}
     * @memberof LiveStreamItem
     */
    platform?: StreamingPlatform;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    channelUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    twitchChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    kickChannelSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    youtubeChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    youtubeLiveId?: string;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamItem
     */
    viewerCount?: number;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamItem
     */
    isLive?: boolean;
    /**
     * 
     * @type {LiveStreamUser}
     * @memberof LiveStreamItem
     */
    user?: LiveStreamUser;
}


/**
 * @export
 */
export const LiveStreamItemTypeEnum = {
    FEATURED: 'FEATURED',
    PARTICIPANT: 'PARTICIPANT'
} as const;
export type LiveStreamItemTypeEnum = typeof LiveStreamItemTypeEnum[keyof typeof LiveStreamItemTypeEnum];


/**
 * Check if a given object implements the LiveStreamItem interface.
 */
export function instanceOfLiveStreamItem(value: object): value is LiveStreamItem {
    return true;
}

export function LiveStreamItemFromJSON(json: any): LiveStreamItem {
    return LiveStreamItemFromJSONTyped(json, false);
}

export function LiveStreamItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LiveStreamItem {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'competitionName': json['competitionName'] == null ? undefined : json['competitionName'],
        'competitionType': json['competitionType'] == null ? undefined : json['competitionType'],
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'label': json['label'] == null ? undefined : json['label'],
        'platform': json['platform'] == null ? undefined : StreamingPlatformFromJSON(json['platform']),
        'channelUrl': json['channelUrl'] == null ? undefined : json['channelUrl'],
        'twitchChannelId': json['twitchChannelId'] == null ? undefined : json['twitchChannelId'],
        'kickChannelSlug': json['kickChannelSlug'] == null ? undefined : json['kickChannelSlug'],
        'youtubeChannelId': json['youtubeChannelId'] == null ? undefined : json['youtubeChannelId'],
        'youtubeLiveId': json['youtubeLiveId'] == null ? undefined : json['youtubeLiveId'],
        'viewerCount': json['viewerCount'] == null ? undefined : json['viewerCount'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'isLive': json['isLive'] == null ? undefined : json['isLive'],
        'user': json['user'] == null ? undefined : LiveStreamUserFromJSON(json['user']),
    };
}

export function LiveStreamItemToJSON(json: any): LiveStreamItem {
    return LiveStreamItemToJSONTyped(json, false);
}

export function LiveStreamItemToJSONTyped(value?: LiveStreamItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'competitionId': value['competitionId'],
        'competitionName': value['competitionName'],
        'competitionType': value['competitionType'],
        'matchId': value['matchId'],
        'label': value['label'],
        'platform': StreamingPlatformToJSON(value['platform']),
        'channelUrl': value['channelUrl'],
        'twitchChannelId': value['twitchChannelId'],
        'kickChannelSlug': value['kickChannelSlug'],
        'youtubeChannelId': value['youtubeChannelId'],
        'youtubeLiveId': value['youtubeLiveId'],
        'viewerCount': value['viewerCount'],
        'thumbnailUrl': value['thumbnailUrl'],
        'isLive': value['isLive'],
        'user': LiveStreamUserToJSON(value['user']),
    };
}

